import styled from "@emotion/styled";

export const TooltipConteiner = styled.div`
  color: ${({ theme }) => theme.other.monochromeColor[0]};

  h2 {
    color: ${({ theme }) => theme.other.primaryColor};
    font-size: 1.25rem;
    margin: 0;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.3;
  }

  div {
    margin-top: 1rem;
    p {
      margin: 0 !important;
    }
  }
`;
